import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TrafficLightColor } from '../../../analysis/models/criterions/TrafficLightColor';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'sera-inputs-and-slider',
    templateUrl: './sera-inputs-and-slider.component.html',
    styleUrl: './sera-inputs-and-slider.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraInputsAndSliderComponent {
    @Input()
    inputId!: string;

    @Input()
    isLeftInputDisabled: boolean = false;

    @Input()
    isRightInputDisabled: boolean = false;

    @Input()
    isRangeSliderDisabled: boolean = false;

    @Input()
    isLeftInputReadOnly: boolean = false;

    @Input()
    isRightInputReadOnly: boolean = false;

    @Input()
    isRangeSliderReadOnly: boolean = false;

    @Input()
    leftInputLabel: string = '';

    @Input()
    rightInputLabel: string = '';

    @Input()
    formGroup: FormGroup | null = null;

    @Input()
    leftInputFormControl: string = '';

    @Input()
    rightInputFormControl: string = '';

    @Input()
    rangeSliderFormControl: string = '';

    @Input()
    leftInputMin: number = 0;

    @Input()
    rightInputMin: number = 0;

    @Input()
    rangeSliderMin: number = 0;

    @Input()
    leftInputMax: number | null = 100;

    @Input()
    rightInputMax: number | null = null;

    @Input()
    rangeSliderMax: number = 100;

    @Input()
    decimalsRightInput: string = '1.0-1';

    @Input()
    color: TrafficLightColor | null = null;

    @Output()
    leftInputValueChanged = new EventEmitter<number>();

    @Output()
    rightInputValueChanged = new EventEmitter<number>();

    @Output()
    rangeSliderValueChanged = new EventEmitter<number>();

    @Output()
    rangeSliderEnd = new EventEmitter<number>();

    onLeftNumberChanged(value: number): void {
        this.leftInputValueChanged.emit(value);
    }

    onRightNumberChanged(value: number): void {
        this.rightInputValueChanged.emit(value);
    }

    onRangeSliderChanged(value: number): void {
        this.rangeSliderValueChanged.emit(value);
    }

    onRangeSliderEnd(value: number): void {
        this.rangeSliderEnd.emit(value);
    }
}
